import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({
    type = 'date',
    size,
    valueFormat,
    format = 'yyyy-MM-dd HH:mm:ss',
    clearable = false,
    disabled = false,
    ...args
  }) {
    super(args)
    const child = this.getComponentWithVModel('el-date-picker')
    child.attrs = {
      ...child.attrs,
      type,
      size,
      format,
      clearable,
      valueFormat,
      disabled
    }
    this.children = [child]
  }
}
